import { useRef, useState, useCallback } from "react";

const SWIPE_THRESHOLD = 80;

export const useSwipeToDismiss = (onDismiss) => {
  const [offsetX, setOffsetX] = useState(0);
  const [swiping, setSwiping] = useState(false);
  const startX = useRef(0);
  const startY = useRef(0);
  const active = useRef(false);
  const locked = useRef(false);

  const onTouchStart = useCallback((e) => {
    startX.current = e.touches[0].clientX;
    startY.current = e.touches[0].clientY;
    active.current = true;
    locked.current = false;
  }, []);

  const onTouchMove = useCallback((e) => {
    if (!active.current) return;
    const dx = e.touches[0].clientX - startX.current;
    const dy = e.touches[0].clientY - startY.current;

    if (!locked.current) {
      if (Math.abs(dy) > Math.abs(dx)) {
        active.current = false;
        return;
      }
      locked.current = true;
    }

    if (dx > 0) {
      setOffsetX(0);
      return;
    }

    setSwiping(true);
    setOffsetX(Math.max(dx, -120));
  }, []);

  const onTouchEnd = useCallback(() => {
    if (!active.current) return;
    active.current = false;
    setSwiping(false);

    if (Math.abs(offsetX) >= SWIPE_THRESHOLD) {
      setOffsetX(-120);
    } else {
      setOffsetX(0);
    }
  }, [offsetX]);

  const resetSwipe = useCallback(() => {
    setOffsetX(0);
    setSwiping(false);
  }, []);

  const isRevealed = Math.abs(offsetX) >= SWIPE_THRESHOLD;

  return {
    offsetX,
    swiping,
    isRevealed,
    resetSwipe,
    handlers: { onTouchStart, onTouchMove, onTouchEnd },
  };
};
